<mat-form-field
	#popoverTrigger="mtxPopoverTrigger"
	(click)="$event.stopPropagation()"
	[mtxPopoverTriggerFor]="projectsPopover"
	class="{{ customFormFieldClass }}"
	floatLabel="never"
	fxFlex
	mtxPopoverTriggerOn="click"
>
	<mat-label [ngClass]="{ 'primary-text': placeholder !== 'Project' }" class="capitalize">
		{{ placeholder }}
	</mat-label>
	<input matInput readonly="true" />
	<mat-icon *ngIf="renderDownArrowIcon()" class="vertical-align-middle" matSuffix>
		keyboard_arrow_down
	</mat-icon>
	<mat-icon
		(click)="$event.stopPropagation(); removeSelectedProject()"
		*ngIf="renderCloseArrowIcon()"
		class="vertical-align-middle danger-text cursor-pointer"
		matSuffix
	>
		close
	</mat-icon>
</mat-form-field>

<mtx-popover #projectsPopover="mtxPopover" [closeOnPanelClick]="false">
	<mat-card class="p-0 primary-border">
		<mat-card-content class="projects-dropdown font-size-14">
			<div class="padding-0-5" fxLayout="row">
				<mat-form-field fxFlex>
					<input
						[(ngModel)]="searchText"
						autocomplete="off"
						matInput
						placeholder="Type to filter"
					/>
				</mat-form-field>
			</div>
			<div
				(click)="isMultiSelectFilter ? null : projectSelected(project)"
				*ngFor="let project of projects | search: 'name' : searchText"
				class="padding-0-5 projects-row cursor-pointer"
				fxLayout="row"
			>
				<div *ngIf="isMultiSelectFilter" class="primary-text" fxFlex fxLayoutAlign="start center">
					<mat-checkbox
						(change)="onProjectToggleSelection(project, $event.checked)"
						[checked]="isProjectSelected(project)"
						[color]="'primary'"
						labelPosition="after"
						class="fs-13"
					>
						{{ project.name }}
					</mat-checkbox>
				</div>
				<div *ngIf="!isMultiSelectFilter" class="primary-text" fxFlex fxLayoutAlign="start center">
					{{ project.name }}
				</div>
			</div>

			<div
				*ngIf="!isLoadingProjectsList && searchText?.length > 0 && projects?.length === 0"
				class="padding-0-5 customer-row"
			>
				<div fxFlex fxLayoutAlign="center center">No Project found.</div>
			</div>
		</mat-card-content>
		<mat-divider *ngIf="hasNextPage"></mat-divider>

		<mat-card-actions *ngIf="hasNextPage">
			<div class="p-1 p-t-0" fxLayoutAlign="end center">
				<span
					(click)="viewMoreProjects()"
					*ngIf="!isLoadingProjectsList"
					class="text-underline primary-text cursor-pointer"
				>
					View More
				</span>
				<mat-spinner *ngIf="isLoadingProjectsList" [diameter]="30"></mat-spinner>
			</div>
		</mat-card-actions>
	</mat-card>
</mtx-popover>
